/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_CONFIGURATIONS, GET_WORKFLOW_FILTERS } from '../actions/settingsActions';

const initialState = {
  dispatchWorkFlowFilters: [],
  filtersFetched: false,
  configurationsFetched: false,
  systemConfigurations: []
};

const typesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIGURATIONS: {
      const systemConfigurations = action.payload;

      return produce(state, (draft) => {
        draft.configurationsFetched = true;
        draft.systemConfigurations = systemConfigurations;
      });
    }

    case GET_WORKFLOW_FILTERS: {
      const dispatchWorkFlowFilters = action.payload;

      return produce(state, (draft) => {
        draft.filtersFetched = true;
        draft.dispatchWorkFlowFilters = dispatchWorkFlowFilters;
      });
    }

    default: {
      return state;
    }
  }
};

export default typesReducer;
